
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shorthand]/legal/agb",
      function () {
        return require("private-next-pages/[shorthand]/legal/agb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shorthand]/legal/agb"])
      });
    }
  